<template>
  <div>
    <PageHeader title="Historique" />

    <div class="my-5 px-4 py-2 bg-white shadow-sm rounded-lg">
      <Selector
        class="mb-4"
        id="store-selector"
        name="store"
        label="Magasin"
        :modelValue="selectedStore?.id"
        :options="storeOptions"
        @update:modelValue="handleStoreChange"
      />
    </div>

    <Loading v-if="loading" />
    <ChallengeList v-else :challenges="challenges" :storeId="selectedStore?.id" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import ChallengesService from "@/api/services/challenges";
import { PageHeader, Selector, Loading, toCamelCase } from "@estaly/ui";
import ChallengeList from "@/components/challenge/ChallengeList.vue";

export default {
  components: {
    PageHeader,
    Selector,
    ChallengeList,
    Loading,
  },

  data() {
    return {
      loading: true,
      challenges: [],
      selectedStore: null,
    };
  },

  computed: {
    ...mapState("store", { stores: "index" }),
    storeOptions() {
      return this.stores.map((store) => ({
        value: store.id,
        label: store.salesChannel || store.name,
      }));
    },
  },

  async mounted() {
    if (this.stores.length > 0) {
      this.selectedStore = this.stores[0];
      await this.retrieveChallenges();
    }
  },

  methods: {
    async retrieveChallenges() {
      this.loading = true;

      const response = await ChallengesService.fetchIndex(this.selectedStore.id, { perPage: 2000 });
      if (response?.success) {
        const data = toCamelCase(response.data);
        this.challenges = data.challenges;
      }
      this.loading = false;
    },

    async handleStoreChange(storeId) {
      const newStore = this.stores.find((store) => store.id === parseInt(storeId, 10));
      this.selectedStore = newStore;
      await this.retrieveChallenges();
    },
  },
};
</script>
